module.exports = __webpack_public_path__ + "img/ic_cadastro.f53c5043.svg";